var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#64D1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90625 8.57137H6.8985V3.9375H9.45619C9.93094 3.9375 10.3641 3.99319 10.7556 4.10456C11.1471 4.21594 11.4823 4.38581 11.7619 4.61306C12.0414 4.84031 12.2602 5.12888 12.4189 5.47706C12.5769 5.82581 12.6562 6.24206 12.6562 6.72638C12.6562 7.21069 12.5719 7.632 12.4048 7.99031C12.2467 8.33594 12.0125 8.64131 11.7197 8.88356C11.4189 9.1272 11.072 9.30761 10.6999 9.414C10.2866 9.5333 9.8582 9.59203 9.42806 9.58837H8.01619V11.0554H10.2662V12.0144H8.01619V14.0625H6.8985V12.0144H5.90625V11.0554H6.8985V9.58837H5.90625V8.57137ZM9.45562 8.57137C10.0986 8.57137 10.6043 8.41894 10.9721 8.11406C11.34 7.80863 11.5245 7.34625 11.5245 6.72638C11.5245 6.10706 11.34 5.6565 10.9721 5.37581C10.6043 5.09456 10.0986 4.95394 9.45619 4.95394H8.01619V8.57137H9.45562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRub);
export default __webpack_public_path__ + "static/media/rub.576791742efe96c8be2b849cb0ed984d.svg";
export { ForwardRef as ReactComponent };